import { useState, Fragment } from "react";
import { Box, Drawer } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getTaskStatusLabels } from "../../../utils/constant";
import { getUserProfileDetails } from "../../../appStore/actions/AppState/action";
import { findUser, setProfileData } from "../../../utils/helper";
import { useTranslation } from "react-i18next";
import TaskCard from "../../../common/TaskCard/TaskCard";
import SubTaskCard from "../../../common/SubTaskCard/SubTaskCard";
import ReopenedHistory from "./Drawer/ReopenedHistory";
import ApprovalMessage from "../Approval/ApprovalMessage";
import arrowSvg from "../../../assets/images/arrow.svg";

// mt + mb = 54 (SVG height) → net layout contribution = 0 → gap stays the same with or without connector.
// mt = 27 pulls arrow 12px into card1's visual border (15px pb - 27 = -12); mb = 27 pulls card2 up to the same position it would be without connector.
const ClosingApprovalConnector = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-end",
      pr: "28px",
      mt: "-35px",
      mb: "-19px",
      position: "relative",
      zIndex: 2,
      pointerEvents: "none",
    }}
  >
    <img src={arrowSvg} alt="" style={{ height: "54px", display: "block" }} />
  </Box>
);

const TaskMessage = ({
  taskItem,
  closingApprovals,
  startTaskOpen,
  setStartTaskOpen,
  handleStartTask,
  indx,
  handleClickTaskUpdate,
  handleViewThreadClick,
  tabValue,
  taskTabValue,
  recipientDetails
}) => {
  const { t } = useTranslation();
  const appConstant = t("AppConstant", { returnObjects: true });
  const taskStatusLabels = getTaskStatusLabels(appConstant);
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [reopenedHostoryDrawer, setReopenedHostoryDrawer] = useState(false);

  const groupmemberdetails = useSelector(
    (state) => state?.arkchatgroup?.groupmember
  );
  const groupList = useSelector((state) => state?.arkchatgroup?.groupList);
  const userData = useSelector((state) => state?.profile);
  const dispatch = useDispatch();

  const handleShowUserProfile = (userToFindData) => {
    let data = findUser(groupmemberdetails, userToFindData);

    if (!data) {
      setProfileViewModal(true);
      dispatch(getUserProfileDetails(userToFindData)).then((res) => {
        data = res;
        setProfileData(data, setProfileViewData, setProfileViewModal);
      });
    } else {
      setProfileData(data, setProfileViewData, setProfileViewModal);
    }
  };

  return (
    <>
      <Box
        draggable
        sx={{
          transition: "all 0.2s ease",
        }}
      >
        <Box
          padding="0px 20px 15px 0px"
          key={taskItem?.id + "TaskMessageMain"}
          sx={{}}
          display={"flex"}
          alignItems={"center"}
        >
          {/* Drag Handle */}

          <Box
            sx={{
              width: "100%",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: "19.5px",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "9px 20px 9px 12px",
            }}
          >
            <TaskCard
              taskItem={taskItem}
              setStartTaskOpen={setStartTaskOpen}
              handleStartTask={handleStartTask}
              indx={indx}
              handleClickTaskUpdate={handleClickTaskUpdate}
              handleViewThreadClick={handleViewThreadClick}
              tabValue={tabValue}
              taskTabValue={taskTabValue}
              userData={userData}
              groupList={groupList}
              taskStatusLabels={taskStatusLabels}
              setProfileViewModal={setProfileViewModal}
              isProfileViewOpen={isProfileViewOpen}
              profileViewData={profileViewData}
              setProfileViewData={setProfileViewData}
              handleShowUserProfile={handleShowUserProfile}
              startTaskOpen={startTaskOpen}
              setReopenedHostoryDrawer={setReopenedHostoryDrawer}
              recipientDetails={recipientDetails}
            />
          </Box>
        </Box>

        {/* Closing approval(s) for the root task */}
        {closingApprovals?.map((ca) => (
          <Fragment key={ca.id}>
            <ClosingApprovalConnector />
            <ApprovalMessage
              taskItem={ca}
              indx={0}
              handleClickTaskUpdate={handleClickTaskUpdate}
              handleViewThreadClick={handleViewThreadClick}
              tabValue={2}
            />
          </Fragment>
        ))}

        {/* Subtasks, each followed by their own closing approval(s) */}
        {taskItem?.balah?.map((subItem, subIndx) => (
          <Fragment key={subItem?.id + "TaskMessageSub1"}>
            <Box
              padding="0px 20px 15px 0px"
              display={"flex"}
              alignItems={"center"}
            >
              <SubTaskCard
                taskItem={subItem}
                setStartTaskOpen={setStartTaskOpen}
                handleStartTask={handleStartTask}
                indx={subIndx + "subtask"}
                subIndex={0}
                handleClickTaskUpdate={handleClickTaskUpdate}
                handleViewThreadClick={handleViewThreadClick}
                tabValue={tabValue}
                taskTabValue={taskTabValue}
                userData={userData}
                groupList={groupList}
                taskStatusLabels={taskStatusLabels}
                setProfileViewModal={setProfileViewModal}
                isProfileViewOpen={isProfileViewOpen}
                profileViewData={profileViewData}
                setProfileViewData={setProfileViewData}
                handleShowUserProfile={handleShowUserProfile}
                startTaskOpen={startTaskOpen}
                recipientDetails={recipientDetails}
              />
            </Box>
            {subItem.closingApprovals?.map((ca) => (
              <Box key={ca.id} sx={{ pl: "2.8rem" }}>
                <ClosingApprovalConnector />
                <ApprovalMessage
                  taskItem={ca}
                  indx={0}
                  handleClickTaskUpdate={handleClickTaskUpdate}
                  handleViewThreadClick={handleViewThreadClick}
                  tabValue={2}
                />
              </Box>
            ))}
          </Fragment>
        ))}
      </Box>
      <Drawer
        disableEnforceFocus
        // hideBackdrop={true}
        anchor={"right"}
        open={reopenedHostoryDrawer}
      >
        <ReopenedHistory
          taskItem={taskItem}
          setReopenedHostoryDrawer={setReopenedHostoryDrawer}
        />
      </Drawer>
    </>
  );
};

export default TaskMessage;
